module.exports = __webpack_public_path__ + "static/logo-c37f90faa94db9eb4cd73a5addb1224c.svg";